import { createApp } from 'vue';
import pinia from './stores/store'
import ElementPlus from 'element-plus';
import zhCn from 'element-plus/dist/locale/zh-cn.mjs';

import * as ElementPlusIconsVue from '@element-plus/icons-vue'

import App from './App.vue';
import router from './router';

// 引入CSS
import './assets/style/main.scss';

// 引入字体图标库
import './assets/iconfont/iconfont';
// 引入 wangeditor css
import '@wangeditor/editor/dist/css/style.css'

import 'amfe-flexible'

const app = createApp(App);

// 全局el-icon
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.use(pinia);
app.use(router);
app.use(ElementPlus, {locale: zhCn});

app.mount('#app');

// 权限判断的指令
import {useRouterListStore} from '@/stores/routers.js';
let routerListStore = useRouterListStore(pinia)
app.directive('authority', (el, binding) => {
  let authenticatedList = routerListStore.authenticatedList
  if (!authenticatedList.get(binding.value)) {
    el?.parentNode?.removeChild(el)
  }
});
